var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRainSnowShowersNight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 76.26 69.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f5b952;}.cls-2{fill:#e5f1fb;}.cls-3,.cls-5{fill:none;stroke:#000;}.cls-3,.cls-4,.cls-5{stroke-miterlimit:10;}.cls-3{stroke-width:1.5px;}.cls-4{fill:#b9e4fa;stroke:#231f20;stroke-width:3px;}.cls-5{stroke-width:5px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "rain-snow-showers-nightAsset 146colored") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.34,26.35c2.34-.47,4.67-1,7-1.48,4.81-1.07,9.77-1.1,14.56-2.15a7.13,7.13,0,0,1,.87-.14A25.33,25.33,0,0,0,22.74,2,25.57,25.57,0,0,0,5.12,9l1.19.37C18.25,13,25.58,18.39,25.34,26.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M73.41,41.35a10.14,10.14,0,0,0-1.94-3.8A9.7,9.7,0,0,0,69,35.24a10.61,10.61,0,0,0-4.21-1.57c-.21,0-.46-.32-.56-.55a10.26,10.26,0,0,0-10.94-6.76,18.22,18.22,0,0,0-3.62,1,1.09,1.09,0,0,1-1.21-.43,12.26,12.26,0,0,0-4.7-4A14.18,14.18,0,0,0,41.67,22c-.37-.1-.74-.21-1.12-.29a10.22,10.22,0,0,0-3-.18,12.17,12.17,0,0,0-1.22.14,11.56,11.56,0,0,0-1.18.24L35,22a21.36,21.36,0,0,0-4.26,2.1,30,30,0,0,0-3.5,3.46c.09,0,0,0-.1-.05a11.44,11.44,0,0,0-5.29-1.38,9.84,9.84,0,0,0-4.66,1.13,11,11,0,0,0-4.83,5.2A2.25,2.25,0,0,1,11,33.52a11.2,11.2,0,0,0-2.89,1,9.67,9.67,0,0,0-3.63,3.26c-.14.22-.29.43-.43.67A12.18,12.18,0,0,0,2.67,42a9.25,9.25,0,0,0,0,3.46A10.32,10.32,0,0,0,11.13,54a1.16,1.16,0,0,1,1,.87,10.22,10.22,0,0,0,8.48,6.62,10,10,0,0,0,5.85-1,1,1,0,0,1,1.28.33,12.66,12.66,0,0,0,20.63.11,1,1,0,0,1,1.28-.33,10.34,10.34,0,0,0,14.46-5.71.85.85,0,0,1,.79-.6A10.34,10.34,0,0,0,73.41,41.35Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 21.22,
    y1: 39.95,
    x2: 21.22,
    y2: 43.86
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "19.83 38.53 21.23 39.93 22.64 38.51"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 21.25,
    y1: 49.83,
    x2: 21.25,
    y2: 45.92
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "22.64 51.25 21.25 49.85 19.83 51.27"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 25.42,
    y1: 47.52,
    x2: 22.1,
    y2: 45.44
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "25.88 49.45 25.44 47.53 27.39 47.08"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 17.05,
    y1: 42.26,
    x2: 20.37,
    y2: 44.33
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "16.59 40.32 17.04 42.25 15.09 42.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 17.05,
    y1: 47.51,
    x2: 20.37,
    y2: 45.44
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "16.58 49.45 17.03 47.52 15.08 47.07"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 25.42,
    y1: 42.27,
    x2: 22.1,
    y2: 44.34
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "25.89 40.33 25.44 42.26 27.39 42.71"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 21.17,
    cy: 44.91,
    r: 1.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 56.76,
    y1: 39.95,
    x2: 56.76,
    y2: 43.86
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "55.36 38.53 56.76 39.93 58.18 38.51"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 56.78,
    y1: 49.83,
    x2: 56.78,
    y2: 45.92
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "58.18 51.25 56.78 49.85 55.36 51.27"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 60.95,
    y1: 47.52,
    x2: 57.64,
    y2: 45.44
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "61.41 49.45 60.97 47.53 62.92 47.08"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 52.59,
    y1: 42.26,
    x2: 55.9,
    y2: 44.33
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "52.13 40.32 52.57 42.25 50.62 42.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 52.59,
    y1: 47.51,
    x2: 55.9,
    y2: 45.44
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "52.12 49.45 52.56 47.52 50.62 47.07"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 60.96,
    y1: 42.27,
    x2: 57.64,
    y2: 44.34
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "61.42 40.33 60.98 42.26 62.92 42.71"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 56.71,
    cy: 44.91,
    r: 1.38
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M38.41,36.21c-1.48,3.33-3.12,6.6-4.47,10-1.1,2.78.51,5.46,3.35,6.35a4.51,4.51,0,0,0,2.39-.06c2.77-1,4.23-3.52,3.15-6.27C41.5,42.83,39.87,39.55,38.41,36.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M49.57,28.3c0-.26,0-.52,0-.78a25.24,25.24,0,0,0-25.45-25,25.57,25.57,0,0,0-17.62,7l1.2.36a25.89,25.89,0,0,1,17.52,18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M73.4,42.2a9.53,9.53,0,0,0-1.72-3.46,10.24,10.24,0,0,0-3.24-2.94,10.36,10.36,0,0,0-3.7-1.23c-.21,0-.47-.33-.56-.55a10.25,10.25,0,0,0-11-6.71,16.79,16.79,0,0,0-3.36.9,1.42,1.42,0,0,1-1.58-.49,12.25,12.25,0,0,0-4.61-3.87,14.27,14.27,0,0,0-2.1-.81c-.36-.1-.73-.21-1.12-.29a10.17,10.17,0,0,0-3-.16A12.47,12.47,0,0,0,35,23a22,22,0,0,0-4.32,2.15,30.89,30.89,0,0,0-3.48,3.48c.09,0,0,0-.1-.05a11.43,11.43,0,0,0-5.3-1.35,9.9,9.9,0,0,0-4.65,1.14,11.16,11.16,0,0,0-5,5.62,1.12,1.12,0,0,1-.76.6A11.53,11.53,0,0,0,8,35.68,9.65,9.65,0,0,0,4.43,39c-.15.22-.3.44-.44.67a12.3,12.3,0,0,0-1.33,3.54,9.18,9.18,0,0,0,0,3.46,10.31,10.31,0,0,0,8.51,8.49,1.2,1.2,0,0,1,1,.87,10.21,10.21,0,0,0,8.51,6.58,9.91,9.91,0,0,0,5.47-.85,1.56,1.56,0,0,1,1.9.48,12.67,12.67,0,0,0,20.14,0,1.58,1.58,0,0,1,1.91-.49,10.32,10.32,0,0,0,14-6,.84.84,0,0,1,.79-.59A10.36,10.36,0,0,0,73.4,42.2Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRainSnowShowersNight);
export default __webpack_public_path__ + "static/media/rain-snow-showers-night.70b740bd0df75f5a12caab1f5d359355.svg";
export { ForwardRef as ReactComponent };